class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    
    const closeBtn = this.querySelector('button[type="button"]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer ? this.detailsContainer.hasAttribute('open') : false;
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (!this.detailsContainer) return;
    const details = event.target.closest('details');
    if (details) {
      details.hasAttribute('open') ? this.close() : this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || (event.target.classList && event.target.classList.contains('modal-overlay'))) this.close(false);
  }

  open(event) {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
      if (this.detailsContainer) {
        this.detailsContainer.classList.remove('menu-closing');
      }
    }
    if (!this.detailsContainer) return;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const details = event.target.closest('details');
    if (details) {
      details.setAttribute('open', true);
    }
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    this.updatePosition();
    this.onScrollPositionEvent = this.onScrollPositionEvent || this.updatePosition.bind(this);
    window.addEventListener('scroll', this.onScrollPositionEvent, { passive: true });

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  updatePosition() {
    if (!this.classList.contains('header__search')) return;
    const searchModal = this.querySelector('.search-modal');
    if (!searchModal) return;

    if (window.innerWidth <= 990) {
      const hasAnnouncement = !!document.querySelector('.announcement-bar, .announcement-bar-section, #shopify-section-announcement-bar');
      const isScrolled = window.scrollY > 30 || !!document.querySelector('.scrolled-past-header');
      
      if (hasAnnouncement && !isScrolled) {
        searchModal.style.setProperty('top', '35.5px', 'important');
      } else {
        searchModal.style.setProperty('top', '0px', 'important');
      }
    } else {
      searchModal.style.removeProperty('top');
    }
  }

  close(focusToggle = true) {
    if (!this.detailsContainer) return;
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    
    if (this.onScrollPositionEvent) {
      window.removeEventListener('scroll', this.onScrollPositionEvent);
    }

    this.detailsContainer.classList.add('menu-closing');
    this.closeTimeout = setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
      this.detailsContainer.classList.remove('menu-closing');
      this.closeTimeout = null;
    }, 300);

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
